<template>
  <b-container
    fluid
    class="bg-white shadow-inset-top"
    style="min-height: calc(100vh - 95px); max-height: calc(100vh - 95px); overflow-y: auto"
    data-cy="returnschedule-container"
  >
    <b-row style="height: 100%" data-cy="returnschedule-row">
      <b-col cols="12">
        <b-container class="p-4 p-md-5" data-cy="returnschedule-content">
          <b-row>
            <b-col cols="12" class="mb-5">
              <h4
                class="text-primary font-weight-bold"
                data-cy="returnschedule-title"
              >
                Data e Hora
              </h4>
              <small
                class="font-weight-bold"
                data-cy="returnschedule-instructions"
              >
                Selecione a data e hora de sua preferência
              </small>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div onselectstart="return false">
                <span
                  class="prev p-4 bg-primary text-white"
                  @click="prev"
                  v-if="false"
                  data-cy="returnschedule-btn-prev"
                >
                  <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                </span>
              </div>
              <div v-if="!loading" data-cy="returnschedule-carousel-wrapper">
                <carousel
                  :nav="false"
                  autoWidth
                  rewind
                  :dots="false"
                  style="width: calc(100% - 0.5rem); float: left;"
                  data-cy="returnschedule-carousel"
                >
                  <schedule-tab-date-item
                    v-for="scheduleday in schedules"
                    :key="scheduleday.id"
                    :scheduleday="scheduleday"
                    :data-cy="`returnschedule-dateitem-${scheduleday.id}`"
                  ></schedule-tab-date-item>
                </carousel>
              </div>
              <div v-if="loading" data-cy="returnschedule-loading"></div>
              <div onselectstart="return false">
                <span
                  class="next p-4 bg-primary text-white"
                  @click="next"
                  v-if="false"
                  data-cy="returnschedule-btn-next"
                >
                  <font-awesome-icon
                    icon="chevron-right"
                    v-if="!loadMore"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    icon="plus"
                    v-if="loadMore"
                  ></font-awesome-icon>
                </span>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="bg-white">
              <hr class="w-100 my-5" />
              <div
                id="workflow-buttons-wrapper"
                class="d-flex justify-content-between"
                data-cy="returnschedule-actions-wrapper"
              >
                <router-link
                  :to="{
                    name: 'return',
                    params: { organizationId: $route.params.organizationId }
                  }"
                  class="btn btn-outline-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
                  data-cy="returnschedule-btn-back"
                  >Voltar e Ajustar</router-link
                >

                <router-link
                  :to="{
                    name: 'return_confirmacao',
                    params: { organizationId: $route.params.organizationId }
                  }"
                  :class="
                    `${
                      !horario ? 'disabled' : ''
                    } btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0`
                  "
                  data-cy="returnschedule-btn-confirm"
                  >Confirmação</router-link
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import Carousel from "vue-owl-carousel";
import ScheduleTabDateItem from "@/components/scheduletabdateitem.vue";
import { axiosInstance as Axios } from "@/main";

export default {
  name: "return-schedule",
  data() {
    return {
      schedules: [],
      loading: true,
      loadMore: false,
      owl: null,
      visualized: 0,
      loadLess: true,
      onePage: 0
    };
  },
  components: {
    Carousel,
    ScheduleTabDateItem
  },
  computed: {
    selectedReturn() {
      return this.$store.getters.selected_return;
    },
    horario() {
      return this.$store.getters.get_selected[3].nome;
    }
  },
  async mounted() {
    try {
      let response = await Axios.get(
        `${this.$serverHost}protected/me/retornos/${this.$store.getters.selected_return.id}/agendas`,
        {
          headers: {
            "X-Organizacao-ID": this.$route.params.organizationId,
            Authorization: `Bearer ${this.$store.getters.token}`
          }
        }
      );

      this.onePage = this.visualized;
      this.schedules = response.data;
    } catch (e) {
      this.$bvToast.toast(e.response.data.message, {
        title: "Erro",
        variant: "danger",
        autoHideDelay: 5000,
        appendToast: true
      });
    }

    this.loading = false;
  },
  methods: {
    next() {
      if (this.visualized >= this.schedules.length - 1 && this.loadMore) {
        let payload = {
          organizationId: this.$route.params.organizationId,
          url: `${this.$serverHost}agendamentos/agendas`,
          date: moment(this.schedules[this.schedules.length - 1].data).format(
            "YYYY-MM-DD"
          )
        };

        this.$store.dispatch("set_loading", true);
        this.$store.dispatch("load_moreschedules", payload).catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: "Erro",
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true
          });
        });
        this.loadMore = false;
      }

      this.loadMore = this.visualized >= this.schedules.length - 1;

      this.owl.next();
      this.visualized += 1;
    },
    prev() {
      if (this.onePage == this.visualized) {
        let payload = {
          organizationId: this.$route.params.organizationId,
          url: `${this.$serverHost}agendamentos/agendas`,
          date: moment(this.schedules[this.schedules.length - 1].data)
            .add(-15, "d")
            .format("YYYY-MM-DD")
        };

        this.$store.dispatch("set_loading", true);
        this.$store.dispatch("load_moreschedules", payload).catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: "Erro",
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true
          });
        });
        this.loadMore = false;
      }

      this.owl.prev();
    },
    changed(e) {
      console.log(e);
    }
  }
};
</script>

<style></style>
